import { ScrollViewWheelCtrlZoom } from "./ScrollViewWheelCtrlZoom.js";
import { ScrollViewWheelScroll } from "./ScrollViewWheelScroll.js";
import { ScrollViewWheelZoom } from "./ScrollViewWheelZoom.js";

export class ScrollViewWheel {
    public static Scroll = new ScrollViewWheelScroll();
    public static Zoom = new ScrollViewWheelZoom();
    public static CtrlZoom = new ScrollViewWheelCtrlZoom();
}